import script from "./SuperadminLoginView.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperadminLoginView.vue?vue&type=script&setup=true&lang=js"

import "./SuperadminLoginView.vue?vue&type=style&index=0&id=2ea5b9c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea5b9c2"]])

export default __exports__